module.exports = __webpack_public_path__ + "img/fleetanServiceAccount.38a6d2ff.jpg";